// extracted by mini-css-extract-plugin
export default {"container":"clinicMenu_container__a5x4O","main":"clinicMenu_main__wPxDg","title":"clinicMenu_title__X41Hd","grid":"clinicMenu_grid__mTRzR"};